module.exports = __webpack_public_path__ + "media/src/assets/Images/WhatsappLogo-594f09b412c8c31c2f57213437bdde53.svg";